import ActionTypes from "../../../constants";
import { BusinessPartnerListReducerType } from "../types";
import BusinessPartnerLists from "..";

const initialState: BusinessPartnerListReducerType = {
  searchQuery: null,
  searchBPSucceeded: false, // searachActionCompleted
  bpList: null,
  paginationInfo: {
    currentPage: 1,
    pageSize: 15,
    totalRecords: 0,
  }
};

const businessPartnerLists = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SEARCH_BP_SUCCEEDED: {
      const { businessPartnerLists: bpList, paginationInfo } = action;

      return {
        ...state,
        bpList,
        // searchQuery,
        paginationInfo,
        searchBPSucceeded: true
      };
    }
    case ActionTypes.RESET_SEARCH_BP_SUCCEEDED_FLAG: {
      return { ...state, searchBPSucceeded: false }
    }
    case ActionTypes.CLEAR_BP_LIST: {
      return {
        ...state,
        bpList: [],
        searchBPSucceeded: false
      };
    }
    default: {
      return state;
    }
  }
};

export default businessPartnerLists;
